import React from "react";
import ResourceViewer from "./ResourceViewer";
import Vegetation from "../../public/Files/pdf/Vegetation_Indices.pdf";


export default function VegetationIndices() {
  return (
    <ResourceViewer
      title="Vegetation Indices"
      description="Learn about vegetation indices and how they help analyze crop health."
      type="pdf"
      file={Vegetation}
    />
  );
}